import {Injectable} from "@angular/core";
import {HttpObservable} from "../../http/services";
import {APIProxy} from "../../http/services";
import {IClientContext} from "../../../app.services/user.context/interfaces/Iclient.context";

@Injectable()
export class ClientContextProxy {
	constructor(private apiHttp:APIProxy) { }

	public getClientContext():HttpObservable<IClientContext> {
		return this.apiHttp.getAnon("ClientContext", "GetClientContext");
	}

	public getClientDNSName():HttpObservable<string> {
		return this.apiHttp.getAnon("ClientContext", "GetClientDNSName");

	}

}
